export default __webpack_public_path__ + "static/spot-liver-64368be6a1cc02f6c70b10dfa9215eb9.jpg";